import { render, staticRenderFns } from "./searchIndex.vue?vue&type=template&id=6b2644d9&scoped=true&"
import script from "./searchIndex.vue?vue&type=script&lang=js&"
export * from "./searchIndex.vue?vue&type=script&lang=js&"
import style0 from "./searchIndex.vue?vue&type=style&index=0&id=6b2644d9&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b2644d9",
  null
  
)

component.options.__file = "searchIndex.vue"
export default component.exports